<template>
  <ValidationProvider
    :skipIfEmpty="false"
    :rules="{ required: { allowFalse: false } }"
    v-slot="{ errors }"
    tag="div"
  >
    <div class="fapi-form-terms f-flex f-items-center f-mt-6">
      <BaseCheckbox
        @input="
          $emit('termsChanged', {
            terms_accepted: $event,
            terms_text: termsText,
          })
        "
        name="terms"
        v-model="value"
        :id="$id('terms')"
      >
        <span v-html="termsText"></span>
      </BaseCheckbox>
    </div>
    <div
      class="fapi-form-terms-errors f-text-red-600 f-text-xs f-mt-1"
      v-if="getFirstError(errors)"
    >
      <span
        v-if="formResource.allow_terms && formResource.require_recurring_terms"
      >
        {{ $t("result.termsAndRecurring.required") }}
      </span>
      <span v-else-if="formResource.allow_terms">
        {{ $t("result.terms.required") }}
      </span>
      <span v-else-if="formResource.require_recurring_terms">
        {{ $t("result.recurring.required") }}
      </span>
    </div>
  </ValidationProvider>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import FormResource from "@/module/Form/Resources/FormResource";
import CheckboxValidationMixin from "@/components/Form/Basic/Inputs/CheckboxValidationMixin";
import { ValidationProvider } from "vee-validate";
import BaseCheckbox from "@/components/Form/Basic/Inputs/BaseCheckbox.vue";

export default Vue.extend({
  name: "Terms",

  components: {
    BaseCheckbox,
    ValidationProvider,
  },

  props: {
    formResource: {
      type: Object as PropType<FormResource>,
      required: true,
    },
  },

  computed: {
    termsText(): string {
      const term: Array<string> = [];
      term.push(this.$t("result.terms.accepting").toString());

      if (this.formResource.allow_terms) {
        if (this.formResource.terms_url) {
          term.push(
            this.createLinkString(
              this.formResource.terms_url,
              this.$t("result.terms.with_terms").toString(),
            ),
          );
        } else {
          term.push(this.$t("result.terms.with_terms").toString());
        }
      }

      if (
        this.formResource.require_recurring_terms &&
        this.formResource.allow_terms
      ) {
        term.push(this.$t("result.terms.and").toString());
      }

      if (this.formResource.require_recurring_terms) {
        if (this.formResource.recurring_terms_url) {
          term.push(
            this.createLinkString(
              this.formResource.recurring_terms_url,
              this.$t("result.terms.with_charging").toString(),
            ),
          );
        } else {
          term.push(this.$t("result.terms.with_charging").toString());
        }
      }

      const fullTermsText = term.join(" ") + ".";

      if (
        this.formResource.allow_terms ||
        this.formResource.require_recurring_terms
      ) {
        return fullTermsText + " *";
      }

      return fullTermsText;
    },
  },

  methods: {
    createLinkString(url: string, link: string): string {
      return (
        '<a href="' +
        url +
        '" rel="noopener" target="_blank" class="f-text-blue-500 hover:f-underline">' +
        link +
        "</a>"
      );
    },
  },

  mixins: [CheckboxValidationMixin],
});
</script>

<style></style>
